export const flatten = (a) =>
  a.reduce((f, tF) => f.concat(Array.isArray(tF) ? flatten(tF) : tF), []);
export const groupBy = (items, key) =>
  items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item],
    }),
    {}
  );

export const distinct = (arr, property) =>
  arr.filter(
    (v, i, a) => a.findIndex((t) => t[property] === v[property]) === i
  );
